import { Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";

@Component({
    selector: "app-blank-layout",

    imports: [RouterOutlet],
    templateUrl: "./blank-layout.component.html",
    styleUrl: "./blank-layout.component.scss"
})
export class BlankLayoutComponent {}
